import { GET_EXPORTED_XEROS_SUCCESS } from 'Reducers/Xero/const'

const initState = {
  xeros: [],
}

export function xero(state = initState, action) {
  switch (action.type) {
    case GET_EXPORTED_XEROS_SUCCESS: {
      return {
        ...state,
        xeros: action.payload.xeros,
      }
    }
    default:
      return state
  }
}
